const COUNTER_ENDPOINT = '/api/visitors';

export async function readVisitorCount(fetchImpl = globalThis.fetch) {
  const response = await fetchImpl(COUNTER_ENDPOINT, {
    method: 'GET',
    credentials: 'same-origin',
    headers: { accept: 'application/json' },
  });
  if (!response.ok) throw new Error(`Visitor counter returned HTTP ${response.status}`);
  const payload = await response.json();
  const count = Number(payload.count);
  if (!Number.isSafeInteger(count) || count < 0) {
    throw new Error('Visitor counter returned an invalid count');
  }
  return {
    count,
    counted: payload.counted === true,
  };
}

export function formatVisitorCount(count) {
  if (!Number.isSafeInteger(count) || count < 0) return '------';
  return String(count).padStart(6, '0').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
